import * as React from 'react';
import { SVGProps } from 'react';
const MiniBotIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 18"
    fill="none"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11 5V1H7M1 11h2m16 0h2m-7-1v2m-6-2v2M5 5h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z"
    />
  </svg>
);
export default MiniBotIcon;
